export * from './replace.directive';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/directives/replace/index.ts